export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrapLive" */'./LiveThemeImporter'),
  },
};
